
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(210|233|482|49|709)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
